module.exports = __webpack_public_path__ + "img/bank-save-transaction.1e77459b.svg";